'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('../../extends-f8003900.js');
var slicedToArray = require('../../slicedToArray-e6d9072a.js');
var React = require('react');
var index = require('../../index-0e40e0c2.js');
var components_Box_Box = require('../Box/Box.js');
var utils_hooks_useDidUpdateEffect = require('../../utils/hooks/useDidUpdateEffect.js');
var components_Icon_Icon = require('../../Icon-97784f8d.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../objectWithoutProperties-aa43106a.js');
require('../../xstyled-prop-types.es-56667676.js');
require('../Image/Image.js');
require('../NuDSProvider/NuDSProvider.js');
require('../../breakpoints-7bb24b2d.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../GlobalStyle/GlobalStyle.js');
require('styled-components');
require('../../theme-340a6118.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');
require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
require('../../styles/themeUtils.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject;
var Header = xstyledStyledComponents_es.styled.button(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  width: 100%;\n  background-color: transparent;\n  text-align: left;\n  cursor: pointer;\n"])));

function CollapseHeader(_ref) {
  var children = _ref.children,
      iconSize = _ref.iconSize,
      isOpen = _ref.isOpen,
      id = _ref.id,
      handleToggleButton = _ref.handleToggleButton,
      iconToClose = _ref.iconToClose,
      iconToOpen = _ref.iconToOpen;
  var buttonIcon = isOpen ? iconToClose : iconToOpen;
  return /*#__PURE__*/React__default['default'].createElement(Header, {
    id: id,
    type: "button",
    onClick: handleToggleButton,
    "aria-controls": "".concat(id, "-body"),
    "aria-expanded": isOpen
  }, children, /*#__PURE__*/React__default['default'].createElement(components_Box_Box['default'], {
    marginLeft: "3x"
  }, /*#__PURE__*/React__default['default'].createElement(components_Icon_Icon.Icon, {
    name: buttonIcon,
    size: iconSize,
    colorVariant: "black"
  })));
}
CollapseHeader.defaultProps = {
  id: undefined,
  isOpen: false,
  handleToggleButton: function handleToggleButton() {},
  iconSize: 'small',
  iconToClose: 'minus',
  iconToOpen: 'plus',
  children: ''
};
CollapseHeader.propTypes = {
  children: index.PropTypes.oneOfType([index.PropTypes.node, index.PropTypes.string]),
  handleToggleButton: index.PropTypes.func,
  iconSize: components_Icon_Icon.IconStructure.propTypes.size,
  iconToClose: index.PropTypes.string,
  iconToOpen: index.PropTypes.string,
  id: index.PropTypes.string,
  isOpen: index.PropTypes.bool
};

function CollapseBody(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      id = _ref.id;
  return /*#__PURE__*/React__default['default'].createElement(components_Box_Box['default'], {
    id: "".concat(id, "-body"),
    display: isOpen ? 'block' : 'none',
    "aria-labelledby": id,
    isOpen: isOpen
  }, children);
}
CollapseBody.defaultProps = {
  id: undefined,
  isOpen: false,
  children: ''
};
CollapseBody.propTypes = {
  children: index.PropTypes.oneOfType([index.PropTypes.node, index.PropTypes.string]),
  id: index.PropTypes.string,
  isOpen: index.PropTypes.bool
};

function Collapse(_ref) {
  var tag = _ref.tag,
      children = _ref.children,
      className = _ref.className,
      onChange = _ref.onChange,
      initiallyOpen = _ref.initiallyOpen,
      id = _ref.id;

  var _useState = React.useState(initiallyOpen),
      _useState2 = slicedToArray.slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      toggleButton = _useState2[1];

  var handleToggleButton = React.useCallback(function () {
    toggleButton(!isOpen);
  }, [isOpen]);

  var onCallback = function onCallback(callback) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (callback) {
      callback(_extends._extends({
        isOpen: isOpen
      }, params));
    }
  };

  utils_hooks_useDidUpdateEffect['default'](function () {
    onCallback(onChange);
  }, [isOpen]);
  var collapseId = "collapse-".concat(id);
  return /*#__PURE__*/React__default['default'].createElement(components_Box_Box['default'], {
    id: id,
    tag: tag,
    className: className,
    borderTop: "2px solid",
    borderTopColor: "black"
  }, React__default['default'].Children.map(children, function (child) {
    return /*#__PURE__*/React__default['default'].cloneElement(child, {
      isOpen: isOpen,
      handleToggleButton: handleToggleButton,
      id: collapseId
    });
  }));
}

Collapse.defaultProps = {
  tag: 'div',
  className: undefined,
  initiallyOpen: false,
  onChange: function onChange() {}
};
Collapse.propTypes = {
  children: index.PropTypes.node.isRequired,
  className: index.PropTypes.string,
  id: index.PropTypes.string.isRequired,
  initiallyOpen: index.PropTypes.bool,
  onChange: index.PropTypes.func,

  /** The actual HTML element to be rendered */
  tag: index.PropTypes.elementType
};
Collapse.Header = CollapseHeader;
Collapse.Body = CollapseBody;

exports.default = Collapse;
//# sourceMappingURL=Collapse.js.map
